export function CheckboxField({
  id,
  checked,
  onChange,
  title,
  description,
}: {
  id: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  title: string;
  description: string;
}) {
  return (
    <label className={`check-field${checked ? " is-checked" : ""}`} htmlFor={id}>
      <input
        id={id}
        className="check-field__input"
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="check-field__box" aria-hidden>
        {checked ? "✓" : ""}
      </span>
      <span className="check-field__copy">
        <strong className="check-field__title">{title}</strong>
        <span className="check-field__desc">{description}</span>
      </span>
    </label>
  );
}
